import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * Earthquake
 *
 * Thin wrapper over the admin earthquake endpoints (list +
 * recorrelate). The import itself runs on an hourly cron; there is no
 * UI trigger. UnauthorizedError propagates so the global handler can
 * bounce the session.
 */
export class Earthquake {
    static async getList(filter) {
        const result = await NetFetch.postData('/json/earthquake/list', filter);
        if (result && result.statusCode === StatusCodes.UNAUTHORIZED) {
            throw new UnauthorizedError();
        }
        if (result && result.statusCode === StatusCodes.OK) {
            return result;
        }
        return null;
    }
    /**
     * Load the impact picture for one earthquake (by id) or a UTC day.
     * Returns focus earthquakes, affected sightings, per-sighting
     * movement tracks, and 4 analytics bucket arrays.
     */
    static async runImpact(request) {
        const result = await NetFetch.postData('/json/earthquake/impact', request);
        if (result && result.statusCode === StatusCodes.UNAUTHORIZED) {
            throw new UnauthorizedError();
        }
        return result !== null && result !== void 0 ? result : null;
    }
    /**
     * Walk every earthquake already in the DB and re-write the
     * sighting_seismic correlations. Used after a configuration
     * change (radius/window) where existing rows need re-evaluation.
     */
    static async runRecorrelate() {
        const result = await NetFetch.getData('/json/earthquake/recorrelate');
        if (result && result.statusCode === StatusCodes.UNAUTHORIZED) {
            throw new UnauthorizedError();
        }
        return result !== null && result !== void 0 ? result : null;
    }
}
